import Ajv from 'ajv/dist/2020';
import addFormats from 'ajv-formats';
export class Validator {
    #jsonSchema;
    #isInitialized = false;
    #ajv;
    #validator;
    #name = '';
    #options = {};
    constructor(jsonSchema, options = {}) {
        this.#jsonSchema = jsonSchema;
        this.#name = options.name || '';
        this.#options = options;
    }
    #init() {
        this.#ajv = new Ajv({ allErrors: true });
        addFormats(this.#ajv);
        if (this.#options.schemaReferences) {
            const schemaRefEntries = Object.entries(this.#options.schemaReferences);
            for (const [key, value] of schemaRefEntries) {
                this.#ajv.addSchema(value, key);
            }
        }
        this.#validator = this.#ajv.compile(this.#jsonSchema);
        this.#isInitialized = true;
    }
    get name() {
        return this.#name;
    }
    validate = (payload) => {
        if (!this.#isInitialized) {
            this.#init();
        }
        const isValidPayload = this.#validator?.(payload);
        if (!isValidPayload) {
            return this.#validator?.errors;
        }
    };
}
